import React from 'react';

export function formatNumber(data: {
    numberOfScreens?: number;
    potentialSpend?: number;
    averageCpm?: number;
    numberOfImpressions?: number;
    numberOfAudienceImpressions?: number;
}, field: 'numberOfScreens' | 'potentialSpend' | 'averageCpm' | 'numberOfImpressions' | 'numberOfAudienceImpressions'): string {
    const value = data[field]!;
    switch (field) {
        case 'numberOfScreens':
        case 'numberOfImpressions':
        case 'numberOfAudienceImpressions':
            return value.toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });
        case 'potentialSpend':
            return value.toLocaleString(undefined, {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
                style: 'currency',
                currency: 'USD',
            });
        case 'averageCpm':
            return value.toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
                style: 'currency',
                currency: 'USD',
            });
    }
}

export function displayKey(field: 'numberOfScreens' | 'potentialSpend' | 'averageCpm' | 'numberOfImpressions' | 'numberOfAudienceImpressions') {
    switch (field) {
        case 'numberOfScreens':
            return 'Number of screens';
        case 'potentialSpend':
            return 'Potential spend';
        case 'averageCpm':
            return 'Average CPM';
        case 'numberOfImpressions':
            return 'Available ad plays';
        case 'numberOfAudienceImpressions':
            return 'Available audience impressions';
    }
}